"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect, useRef } from "react";

export function PostHogProvider({ children }) {
  const maxPercentage = useRef(0);
  const maxPixels = useRef(0);

  useEffect(() => {
    // posthog.featureFlags.overrideFeatureFlags({
    //   flags: { "exp-name": "test" },
    // });

    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      defaults: "2025-05-24",
      capture_pageleave: false,
    });

    function handleScroll() {
      const lastPercentage = Math.min(
        1,
        (window.innerHeight + window.pageYOffset) / document.body.offsetHeight
      );
      const lastPixels = window.innerHeight + window.pageYOffset;

      if (lastPercentage > maxPercentage.current) {
        maxPercentage.current = lastPercentage;
      }

      if (lastPixels > maxPixels.current) {
        maxPixels.current = lastPixels;
      }
    }

    const handlePageLeave = () => {
      posthog.capture("$pageleave", {
        "max scroll percentage": maxPercentage.current,
        "max scroll pixels": maxPixels.current,
        "last scroll percentage": Math.min(
          1,
          (window.innerHeight + window.pageYOffset) / document.body.offsetHeight
        ),
        "last scroll pixels": window.innerHeight + window.pageYOffset,
        scrolled: maxPixels.current > 0,
      });
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("beforeunload", handlePageLeave);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("beforeunload", handlePageLeave);
    };
  }, []);

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
